import React from "react";
import "./Frame114.css";
import { Link, useHistory } from "react-router-dom";

function Frame114() {
  return (
    <Link to="/functional-view-1">
      <div className="frame-114">
        <div className="modeling-1 valign-text-middle inter-medium-star-dust-18px">
          Modeling
        </div>
      </div>
    </Link>
  );
}

export default Frame114;
